import React, { createContext, useContext } from 'react';
import SocialResumeDetail from '@src/nodes/personalCenter/resumeDetail/store/socialResumeDetail';
import CampusResumeDetail from '@src/nodes/personalCenter/resumeDetail/store/campusResumeDetail';
import CampusResumeFormRefStore from '@src/nodes/personalCenter/resumeDetail/store/campusResumeFormRefStore';
import SocialResumeFormRefStore from '@src/nodes/personalCenter/resumeDetail/store/socialResumeFormRefStore';
import EnumResumeDetailStore from '@src/nodes/personalCenter/resumeDetail/store/enumResumeStore';
import { HomeStore } from './home';
import { LoginStore } from './login';
import JobListSotre from './jobList';
import OurTeamStore from './ourTeam';
import JobCommonStore from './jobCommon';
import JobDetailStore from './jobDetail';
import DeliveryStore from './delivery';
import SharePositionStore from './sharePositionList';
import CmsData from './cms';

class StoreInit {
  homeStore;

  loginStore;

  JobListSotre;

  OurTeamStore;

  JobCommonStore;

  JobDetailStore;

  DeliveryStore;

  socialResumeDetail;

  campusResumeDetail;

  campusResumeFormRefStore;

  socialResumeFormRefStore;

  EnumResumeDetailStore;

  SharePositionStore;

  cmsData: CmsData;

  constructor() {
    this.homeStore = HomeStore;
    this.loginStore = LoginStore;
    this.JobListSotre = JobListSotre;
    this.OurTeamStore = OurTeamStore;
    this.JobCommonStore = JobCommonStore;
    this.JobDetailStore = JobDetailStore;
    this.DeliveryStore = DeliveryStore;
    this.SharePositionStore = SharePositionStore;
    this.socialResumeDetail = new SocialResumeDetail();
    this.campusResumeDetail = new CampusResumeDetail();
    this.campusResumeFormRefStore = new CampusResumeFormRefStore();
    this.socialResumeFormRefStore = new SocialResumeFormRefStore();
    this.EnumResumeDetailStore = new EnumResumeDetailStore();
    this.cmsData = new CmsData();
  }
}
const RootStore = new StoreInit();

const RootStoreContext = createContext(RootStore);
const RootStoreProvider = ({ rootStore, children }) => {
  const { ...storeList } = rootStore;
  return <RootStoreContext.Provider value={storeList}>{children}</RootStoreContext.Provider>;
};

const useRootStore = () => {
  return useContext(RootStoreContext);
};

export { RootStore, RootStoreProvider, useRootStore };
